import { type } from 'ramda'
import React from 'react'

import { useModalData } from '../../../components/modals/ModalsContext'
import { useOpenEditWidgetModal } from '../../../utils/routes/modals/modalsActions'
import WidgetPicker from '../../../containers/screens/widgets/WidgetPicker'

const WidgetsList = props => {
  const { screenId } = useModalData()
  const editNewWidget = useOpenEditWidgetModal()

  const handleSelect = ({ id: type, name, initialState }) => {
    editNewWidget({ initialState: { screenId, name, ...initialState, data: { ...initialState?.data, type } } })
  }

  return <WidgetPicker onChange={handleSelect} />
}

export default WidgetsList
